import './rhlConfig';
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import './index.css'
import { App } from './App'
import  store from "./store"
import { ConfigProvider } from 'antd';
import ru_RU from 'antd/lib/locale-provider/ru_RU'
import 'moment/locale/ru'
import { YMaps } from '@pbe/react-yandex-maps';

//import { configureFakeBackend } from './helpers/fake-backend';
//configureFakeBackend();
import registerServiceWorker from './registerServiceWorker'

ReactDOM.render(
	<Provider store={store}>
		<ConfigProvider locale={ru_RU}>
			<YMaps query={{ lang: 'ru_RU' }}>
				<App />
			</YMaps>
		</ConfigProvider>
	</Provider>,

	document.getElementById('root'));

registerServiceWorker()
